import { LoadingIndicator, LocalesMenuButton } from 'react-admin';

/**
 * The notification bell is deliberately NOT here: it is mounted next to the user menu by `AppBar`,
 * so it sits with the identity controls rather than with the locale/loading utilities.
 */
export const AppBarToolbar = () => (
    <>
        <LocalesMenuButton />
        <LoadingIndicator />
    </>
);
